<template>
  <Text
    :as="level"
    :variant="level"
    :color="color"
    :weight="weight"
    :align="align"
    :truncate="truncate"
    :line-clamp="lineClamp"
    :responsive="responsive"
    :transform="transform"
    :class="class"
  >
    <slot></slot>
  </Text>
</template>

<script setup>
import Text from './Text.vue'

defineProps({
  // Heading level (h1-h6)
  level: {
    type: String,
    default: 'h2',
    validator: (value) => ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(value)
  },
  
  // Color
  color: {
    type: String,
    default: 'default'
  },
  
  // Weight (overrides default)
  weight: {
    type: String,
    default: null
  },
  
  // Alignment
  align: {
    type: String,
    default: null
  },
  
  // Truncate
  truncate: {
    type: Boolean,
    default: false
  },
  
  // Line clamp
  lineClamp: {
    type: [Number, null],
    default: null
  },
  
  // Responsive (enabled by default for headings)
  responsive: {
    type: Boolean,
    default: true
  },
  
  // Transform
  transform: {
    type: String,
    default: null
  },
  
  // Custom classes
  class: {
    type: String,
    default: ''
  }
})
</script>

